import type {
  BlockEditorMapping,
  BlockExportMapping,
  BlockMetaMapping,
  BlockRendererMapping,
} from "@circle-react-shared/BuilderUI/BuilderUI.types";
import { isTemplateExport } from "@circle-react-shared/BuilderUI/Helpers/typePredicates";

export const createBlockRendererMapping = (
  blocks: BlockExportMapping,
): BlockRendererMapping =>
  Object.entries(blocks).reduce((acc, [key, block]) => {
    if (isTemplateExport(block)) {
      return acc;
    }
    return {
      ...acc,
      [key]: block.Block,
    };
  }, {});

export const createBlockEditorMapping = (
  blocks: BlockExportMapping,
): BlockEditorMapping =>
  Object.entries(blocks).reduce((acc, [key, block]) => {
    if (isTemplateExport(block)) {
      return acc;
    }
    return {
      ...acc,
      [key]: block.Editor,
    };
  }, {});

export const createBlockMetaMapping = (
  blocks: BlockExportMapping,
): BlockMetaMapping =>
  Object.entries(blocks).reduce(
    (acc, [key, block]) => ({
      ...acc,
      [key]: block.meta,
    }),
    {},
  );
